<ng-template #viewToggle>
  <app-view-toggle
    *ngIf="(!isLoading || !isEmpty) && allowGrid"
    [view]="view"
    (viewToggled)="toggleView($event)"
  ></app-view-toggle>
</ng-template>

<div class="scroll-container" #scrollContainer>
  <div
    class="search-content"
    [class.sidebar-collapsed]="!filterPanelState?.expanded"
  >
    <div class="search-results search-input">
      <button
        *ngIf="hasPreviousUrl"
        class="back"
        (click)="goToPreviousPage()"
        data-automation-id="back-button"
      >
        <span class="icon-back icon"></span>
        <span translate class="text">backButton</span>
      </button>
      <app-search-bar
        class="search-bar"
        [scrollEvent]="scrollEvent.asObservable()"
      ></app-search-bar>
    </div>

    <div
      aria-live="polite"
      role="status"
      *ngIf="isLoading && isEmpty"
      class="d-flex justify-content-center mt-20"
    >
      <div
        class="spinner-border text-primary search-results-loading-spinner"
        data-automation-id="search-results-loading-spinner"
      >
        <span class="sr-only" translate>Loading...</span>
      </div>
    </div>

    <ng-container *ngIf="!showSearchInstruction; else searchInstruction">
      <div class="search-results search-results-count" *ngIf="!isLoading">
        <div class="total-results">
          <div
            tabindex="0"
            class="message search-results-message"
            *ngIf="!isEmpty && isAC"
            aria-atomic="true"
            aria-live="polite"
            role="status"
          >
            <span data-automation-id="counter-with-results">
              <span>{{ calculatedTotalResults }}</span>
              <span
                translate
                [translateParams]="{ value: calculatedTotalResults }"
                data-automation-id="counter-with-results-title"
              >
                searchResultsAmountRelatedTo
              </span>
              <span *ngIf="queryText" translate>
                searchResultsFoundForMessage
              </span>
              <span *ngIf="!queryText" translate>
                searchResultsRelatedToMessage
              </span>
              <span
                class="queryText"
                data-automation-id="counter-with-results-queryText"
                >{{ queryText || resource }}</span
              >
            </span>
            <span
              *ngIf="featureRapidoSearch"
              data-automation-id="rapido-search-link"
            >
               <a class="rapido-search-link"  *ngIf="isRapidoMode" (click)="onRapidoSearch()" translate>
                {{ 'returnToCatalog'| translate }}
              </a>
               <a class="rapido-search-link" *ngIf="!isRapidoMode" (click)="onRapidoSearch()" translate>
                {{ 'rapidoSearch'| translate }}
              </a>
            </span>
            <div
              class="results-number-counter d-lg-none current-number-of-results-container mt-4"
              translate
              [translateParams]="{
                resultsStart: resultsStart,
                resultsEnd: resultsEnd,
                calculatedTotalResults: calculatedTotalResults
              }"
              aria-live="polite"
            >
              currentNumberOfResults
            </div>
          </div>
          <div
            class="message message--empty"
            *ngIf="
              isEmpty && (queryText || resource) != '' && !isConnectionError
            "
            data-automation-id="counter-empty"
            aria-live="polite"
          >
            <span data-automation-id="counter-empty-title">
              <span translate>noResultsRelatedTo</span>
              <span *ngIf="queryText" translate>
                searchResultsFoundForMessage
              </span>
              <span *ngIf="!queryText" translate>
                searchResultsRelatedToMessage
              </span>
            </span>
            <span
              class="queryText"
              data-automation-id="counter-empty-queryText"
              >{{ queryText || resource }}</span
            >
          </div>
          <ng-container *ngIf="isConnectionError">
            <span
              class="message"
              translate
              data-automation-id="connection-error"
            >
              connectionErrorMessage
            </span>
          </ng-container>
          <div
            class="d-flex align-baseline justify-content-between search-actions mt-1 mt-lg-0"
          >
            <div class="d-flex align-items-center">
              <app-share-icons-button
                *ngIf="srpShowShareIcon"
                [isSearchPage]="true"
                [shareData]="shareData"
                [bigButton]="true"
              ></app-share-icons-button>
              <app-save-search-button
                *featureToggle="'licenseSavedSearches'"
              ></app-save-search-button>
            </div>
            <app-custom-pass-through
              *featureToggle="'DIS-31141_2024-06-30_passthrough_search'"
            ></app-custom-pass-through>
            <app-inn-reach-search
              *featureToggle="'!DIS-31141_2024-06-30_passthrough_search'"
            ></app-inn-reach-search>
          </div>
        </div>
        <div
          *ngIf="truncatedSearch"
          data-automation-id="truncated-search-message"
          class="message"
        >
          <span class="bold">{{ truncatedSearch.firstTruncatedWord }} </span>
          <span
            translate
            [translateParams]="{ value: truncatedSearch.maxSearchWords }"
            >truncatedSearch</span
          >
        </div>
        <div class="message message--did-you-mean" *ngIf="showDidYouMean()">
          <span translate id="did-you-mean">didYouMean</span>
          <a
            class="suggestion"
            [routerLink]="['/search']"
            [queryParams]="{
              query: alternativeSearchText,
              searchType: moreParams.searchType
            }"
            [attr.aria-describedby]="'did-you-mean'"
            data-automation-id="did-you-mean-suggestion"
            [innerHTML]="alternativeSearch"
          ></a
          >?
        </div>
        <div class="filtering" *ngIf="!isEmpty">
          <div
            class="results-number-counter d-none d-lg-block current-number-of-results-container"
            translate
            [translateParams]="{
              resultsStart: resultsStart,
              resultsEnd: resultsEnd,
              calculatedTotalResults: calculatedTotalResults
            }"
          >
            currentNumberOfResults
          </div>
          <div
            class="d-none d-sm-flex justify-content-between justify-content-lg-end change-results-number-container"
          >
            <app-search-res-number
              [focus$]="focusResultsNumberButton$"
              class="change-results-number"
              (onChange)="changeNumberOfSearchResults($event)"
              [value]="pageSize"
            >
            </app-search-res-number>
            <div class="sort-toggle-container">
              <search-res-sort
                *ngIf="sortValue"
                [focus$]="focusSortButton$"
                class="sorted-by"
                (onChange)="sort($event)"
                [value]="sortValue"
              >
              </search-res-sort>
              <!--   Desktop  -->
              <div class="d-none d-lg-block">
                <ng-container *ngTemplateOutlet="viewToggle"></ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="bubbles" *ngIf="!isLoading">
          <app-search-facets></app-search-facets>
        </div>
      </div>
      <!--   Mobile  -->
      <div class="d-flex d-md-none flex-column" *ngIf="!isEmpty">
        <div class="d-flex justify-content-between mx-4">
          <button
            #refineResultsButton
            data-automation-id="refine-toggle"
            class="refine-toggle ins-buttons button-secondary pr-0 pl-1 mr-2"
            (click)="onRefineToggle()"
          >
            <span translate>refineResults</span>
            <span
              [ngClass]="
                filterPanelState?.fullscreen
                  ? 'icon-angle-down-thin'
                  : 'icon-angle-right-thin'
              "
            ></span>
          </button>
          <button
            class="sort-toggle ins-buttons button-secondary pr-0 ml-0"
            data-automation-id="sort-actions-button"
            (click)="onSortToggle()"
          >
            <span translate>bookmarksSortBy</span>
            <span
              [ngClass]="
                filterPanelState?.fullscreen
                  ? 'icon-angle-down-thin'
                  : 'icon-angle-right-thin'
              "
            ></span>
          </button>
          <ng-container *ngTemplateOutlet="viewToggle"></ng-container>
        </div>
        <div class="mx-4 mt-2 mb-2">
          <app-bulk-select-panel
            *ngIf="(!isLoading || !isEmpty) && !isRapidoMode"
            [items]="entities$ | async"
            [bulkFeatureKey]="bulkFeatureKey"
            class="non-flex"
          >
          </app-bulk-select-panel>
        </div>
      </div>
      <!--   Desktop  -->
      <div
        class="d-none d-md-flex flex-row mx-lg-6 mx-4 mb-4 mb-lg-6"
        *ngIf="!isEmpty"
      >
        <div class="d-flex justify-content-between w-100">
          <app-bulk-select-panel
            *ngIf="(!isLoading || !isEmpty) && !isRapidoMode"
            [items]="entities$ | async"
            [bulkFeatureKey]="bulkFeatureKey"
            class="non-flex"
          >
          </app-bulk-select-panel>
          <button
            class="sort-toggle ins-buttons button-secondary d-flex d-sm-none pr-0 ml-0"
            data-automation-id="sort-actions-button"
            (click)="onSortToggle()"
          >
            <span translate>bookmarksSortBy</span>
            <span
              [ngClass]="
                filterPanelState?.fullscreen
                  ? 'icon-angle-down-thin'
                  : 'icon-angle-right-thin'
              "
            ></span>
          </button>
          <div class="d-lg-none">
            <ng-container *ngTemplateOutlet="viewToggle"></ng-container>
          </div>
        </div>
      </div>

      <app-entities
        *ngIf="!isLoading || !isEmpty || !view"
        [entities]="entities$ | async"
        [isEmpty]="isEmpty"
        [view]="view"
        [pagination]="pagination"
        [bulkFeatureKey]="bulkFeatureKey"
        (pageSelected)="goToPage($event)"
      >
      </app-entities>

      <div
        class="hints"
        *ngIf="!isLoading && displayHints && !isConnectionError"
        [ngClass]="{ 'extra-margin': appliedFacetsArrayLength }"
      >
        <ul class="hints__title">
          <span translate>searchHintsTitle</span>
          <li class="hints__line" translate>useExactPhraseHint</li>
          <li class="hints__line" translate>checkYourSpellingHint</li>
          <li class="hints__line" translate>@ReduceNumberOfKeywordsHint</li>
          <li
            *ngIf="
              moreParams.searchType != null &&
              moreParams.searchType !== 'everything'
            "
            class="hints__line"
            translate
          >
            searchByDifferentIndexHint
          </li>
          <li class="hints__line" translate *ngIf="appliedFacetsArrayLength">
            tryDifferentOptionsHint
          </li>
        </ul>
      </div>
    </ng-container>
  </div>
  <app-sort-mobile
    *ngIf="isSortVisible"
    [focusResultsNumberButton$]="focusResultsNumberButton$"
    [calculatedTotalResults]="calculatedTotalResults"
    [focusSortButton$]="focusSortButton$"
    [resultsStart]="resultsStart"
    [resultsEnd]="resultsEnd"
    [pageSize]="pageSize"
    [sortValue]="sortValue"
    (closeSort)="onSortToggle()"
    (searchNumberChanged)="changeNumberOfSearchResults($event)"
    (sortChanged)="sort($event)"
  >
  </app-sort-mobile>
  <app-monster-help-v2
    class="monster-help-large-bottom-right d-none d-lg-block"
  ></app-monster-help-v2>
  <app-universal-footer></app-universal-footer>
</div>

<ng-template #searchInstruction>
  <app-advanced-search-instruction
    *ngIf="!isLoading"
  ></app-advanced-search-instruction>
</ng-template>
